import { toast } from '@/components/toast';
import { useRefetchPresentersList } from '@/hooks';
import { NotificationTopics, useNotifications } from '@/services/notification/notificationProvider';
import { ALL_VOICES_ID } from '@/state/presenters';
import { Subject } from '@d-id/types';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { VALIDATE_USER_CAPPING_QUERY_KEY } from './useValidateUserCapping';

export const useSceneNotifications = () => {
    const { subscribe, unsubscribe } = useNotifications();
    const { refetchPresentersList } = useRefetchPresentersList();
    const queryClient = useQueryClient();

    useEffect(() => {
        const subscriptionId = subscribe(NotificationTopics.scene, async (event: MessageEvent) => {
            try {
                await refetchPresentersList();
                const parsedMessage = JSON.parse(event.data);
                const subject = parsedMessage.messageAttributes.subject.stringValue;

                if (subject === Subject.SceneAvatarPostFailed) {
                    queryClient.invalidateQueries(VALIDATE_USER_CAPPING_QUERY_KEY);
                    toast.error({ title: 'Failed to create your Express Avatar' });
                } else if (subject === Subject.SceneAvatarPostDone) {
                    queryClient.invalidateQueries(ALL_VOICES_ID, { refetchInactive: true });
                    toast.success({ title: 'Your Express Avatar was created successfully!' });
                    // TODO: 20-10-2024 omertz added to fetch for preview express, if fixed
                    // in some other way (added before the done phase/trigger refetch in new modal, can remove)
                    setTimeout(() => refetchPresentersList(), 1000 * 60);
                }
            } catch {}
        });
        return () => {
            unsubscribe(NotificationTopics.scene, subscriptionId);
        };
    }, []);
};
